import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  DialogActions,
  FormControl,
  FormGroup,
  Grid,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Add from "@material-ui/icons/Add";
import Search from "@material-ui/icons/Search";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { mapActionsToProps } from "../../redux/cloudPBX/partnerSwitchboard";
import Dialog from "./../../components/Dialog";
import TableData from "./../../components/TableData";
import datetimeHelper from "./../../helper/datetime-helper";
import { globalHistory } from "./../../history";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  bulletOffline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "red",
  },
  bulletOnline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "chartreuse",
  },
});

class PartnerSwitchboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      note: "",
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalEdit: false,
      modalDelete: false,
      modalAction: false,
      tags: "",
    };
  }
  componentDidMount() {
    this.itemInit();
    this.history = globalHistory();
  }

  listColumns = [
    { id: "name", numeric: true, disablePadding: false, label: "Tên tổng đài" },
    { id: "ip", numeric: true, disablePadding: false, label: "IP" },
    {
      id: "updatedAt",
      numeric: true,
      disablePadding: false,
      label: "Thời gian cập nhật",
    },
    { id: "action", numeric: true, disablePadding: false, label: "Hành động" },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "name":
            case "status":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({ time: { gte: this.state.filters.where.from } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.to } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getListPartnerSwitchBoard(
      filters.order,
      filters.pageSize,
      filters.page,
      {
        where,
      }
    );
    this.props.countListPartnerSwitchBoard({ where });
  }

  openDialogCreate = () => {
    this.setState({ modalSend: !this.state.modalSend });
  };

  handleClose = () => {
    this.setState({
      modalSend: false,
      modalAction: false,
      modalDelete: false,
      name: "",
      ip: "",
      port: "",
    });
  };

  openModalEdit = (item) => {
    this.setState({ selectedSubOrg: "" });
    this.state.item = item;
    this.setState({ modalAction: true });
  };

  openModalDelete = (item) => {
    this.state.item = item;
    this.setState({ modalDelete: true });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = { like: value, options: "i" };
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD");
    this.setState({ to });
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value,
        },
      });
    };
  };

  handleCreateModel = () => {
    this.setState({ modalAction: true, item: {} });
  };

  handleAction = () => {
    const { id } = this.state.item;
    if (!id) {
      const { name, ip, port } = this.state;
      return (
        this.props.addPartnerSwitchBoard(name, ip, port, this.state.filters),
        setTimeout(
          function () {
            this.setState({ modalAction: false, name: "", ip: "", port: "" });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    } else {
      const { id, name, ip, port } = this.state.item;
      return (
        this.props.editPartnerSwitchBoard(
          id,
          name,
          ip,
          port,
          this.state.filters
        ),
        setTimeout(
          function () {
            this.setState({ modalAction: false, name: "", ip: "", port: "" });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    }
  };

  handleDelete = () => {
    this.props.deletePartnerSwitchBoard(this.state.item.id, this.state.filters);
    setTimeout(
      function () {
        this.setState({ modalDelete: false });
        this.itemInit();
      }.bind(this),
      500
    );
  };

  render() {
    const { classes, partnerSwitchboards } = this.props;
    const { port, name, ip, filters, item, modalDelete } = this.state;
    const listPartnerSwitchboard =
      typeof partnerSwitchboards === "object"
        ? Object.keys(partnerSwitchboards).map(
            (key) => partnerSwitchboards[key]
          )
        : partnerSwitchboards;
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container spacing={24}>
                      <Grid item md={3}>
                        <TextValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Tên tổng đài"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.name?.like || ""}
                          name="name"
                        />
                      </Grid>
                      <Grid item md={3}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            onClick={this.handleSubmit}>
                            <Search />
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách tổng đài đối tác"
          items={listPartnerSwitchboard}
          rowsPerPage={filters.pageSize}
          count={this.props.count ? this.props.count.count : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listColumns}
          allowCreate={true}
          handleEdit={this.openModalEdit}
          handleDelete={this.openModalDelete}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          createAction={
            <Tooltip title="Thêm mới" disableFocusListener>
              <Fab
                color="primary"
                aria-label="add"
                className={classes.fab}
                size="small"
                onClick={this.handleCreateModel}>
                <Add className={classes.add} />
              </Fab>
            </Tooltip>
          }
        />
        <Dialog
          open={this.state.modalAction}
          title={
            item ? (item.id ? "Chỉnh sửa tổng đài" : "Thêm mới tổng đài") : null
          }
          fullScreen={false}
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleAction}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <Grid container className={classes.grid}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tên tổng đài"
                    variant="outlined"
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("name")
                          : this.handleChangeText("name")
                        : null
                    }
                    value={item ? (item.id ? item.name : name) : null}
                    name="name"
                    validators={["required"]}
                    errorMessages={["Không được để trống"]}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="IP tổng đài kết nối"
                    variant="outlined"
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("ip")
                          : this.handleChangeText("ip")
                        : null
                    }
                    value={item ? (item.id ? item.ip : ip) : null}
                    name="ip"
                    validators={["required"]}
                    errorMessages={["Không được để trống"]}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Port tổng đài kết nối"
                    variant="outlined"
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("port")
                          : this.handleChangeText("port")
                        : null
                    }
                    value={item ? (item.id ? item.port : port || "") : null}
                    name="port"
                    type="number"
                    validators={["required", "matchRegexp:^[0-9]+$"]}
                    errorMessages={[
                      "Không được để trống",
                      "Chỉ cho phép chọn số nguyên dương",
                    ]}
                  />
                </Grid>
                <DialogActions>
                  <Button
                    onClick={this.handleClose}
                    color="secondary"
                    className={classes.button}>
                    Hủy
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.button}>
                    Lưu
                  </Button>
                </DialogActions>
              </FormControl>
            </ValidatorForm>
          }
          onClose={this.handleClose}
        />
        <Dialog
          open={modalDelete}
          title={`Bạn có muốn xóa tổng đài?`}
          button={true}
          onSubmit={this.handleDelete}
          onClose={this.handleClose}
        />
      </React.Fragment>
    );
  }
}

PartnerSwitchboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  partnerSwitchboards: state.partnerSwitchboard.partnerSwitchboards,
  count: state.partnerSwitchboard.count,
});

PartnerSwitchboard = connect(
  mapStateToProps,
  mapActionsToProps
)(PartnerSwitchboard);

export default withStyles(styles)(PartnerSwitchboard);
